import { LeadStageType } from '@/Mapper/LeadStageType';
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('leadAgentMappingStore', [
      'leadStageIsLessThanSold',
    ]),
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadStage',
    ]),
    soldUpdates() {
      return new Promise((resolve, reject) => {
        this.createCaseForSaleUpdate();
        if (this.leadStageIsLessThanSold) {
          this.moveLeadToSold()
            .then(() => {
              this.logLeadEvent(
                'Leads Management - Submit status change - Sold',
                'Single Deal Page - Post-Listed',
              );
              resolve(true);
            });
        } else {
          resolve(true);
        }
      });
    },
    moveLeadToSold() {
      const payload = {
        leadkey: this.lead.key,
        data: {
          leadstagetypeid: LeadStageType.Sold,
          oauserkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
          sourcetypeid: this.isLamOwner ? 1 : 5,
        },
      };
      return this.updateLeadStage(payload);
    },
  },
};
